<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-container>
          <dashboard-filtro-mais-vida
            :empresas="enableEmpresa"
            :url="link"
            :clientes="enableClientes"
            :cidades="enableCidades"
            :areas="enableAreas"
            :vendedores="enableVendedores"
            :redes="enableRedes"
            :produtos="enableProdutos"
            :linhas="enableLinhas"
            :segmentos="enableSegmento"
            :btn1="enableBtn"
            :btn2="disableBtn"
          />
        </v-container>
        <v-container>
          <v-row
            v-if="enableBtnPrint"
            id="btnPrint"
          >
            <v-btn
              class="col-4 col-sm-3 col-md-1 col-lg-1"
              small
              :color="corPrimaria"
              dark
              :loading="imprimindo"
              @click="imprimir()"
            >
              <v-icon>
                mdi-printer
              </v-icon>
              Imprimir
              <template v-slot:loader>
                <span>Imprimindo...</span>
              </template>
            </v-btn>
          </v-row>
        </v-container>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <h2 class="text-center">
              Clientes Totais: {{ clienteTotal }}
            </h2>
          </v-col>
        </v-row>
        <v-row id="participacaoUltimosMesesPrint">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Participação de Clientes Últimos 3 Meses
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('232')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row
                  id="graficoPositivacao"
                  class="container"
                >
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                  >
                    <dashboard-grafico-positivacao-clientes-novos />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                  >
                    <dashboard-grafico-cliente-sem-movimentacao />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                  >
                    <dashboard-grafico-cliente-novos-sem-movimentacao />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                  >
                    <dashboard-grafico-cliente-novos-movimentacao />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row id="participacaoUltimoAnoPrint">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Participação de Clientes Últimos 12 Meses
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('340')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div> <v-card-actions>
                <v-row
                  id="graficoPositivacao"
                  class="container"
                >
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                  >
                    <dashboard-grafico-positivacao-clientes-novos-anual />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                  >
                    <dashboard-grafico-cliente-sem-movimentacao-anual />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                  >
                    <dashboard-grafico-cliente-novos-sem-movimentacao-anual />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                  >
                    <dashboard-grafico-cliente-novos-movimentacao-anual />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import PositivacaoCliente from '../../../../services/positivacaocliente'
  import eventEmit from '../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'
  import html2canvas from 'html2canvas'

  export default {
    name: 'PageMaisVida06',
    emits: ['updateFormMaisVida', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroMaisVida: () => import('../../components/core/FiltrosMaisVida'),
      DashboardGraficoPositivacaoClientesNovos: () => import('../../graficos/Comercial/PositivacaoCliente'),
      DashboardGraficoClienteSemMovimentacao: () => import('../../graficos/Comercial/ClienteSemMovimentacao'),
      DashboardGraficoClienteNovosSemMovimentacao: () => import('../../graficos/Comercial/ClienteNovosSemMovimentacao'),
      DashboardGraficoClienteNovosMovimentacao: () => import('../../graficos/Comercial/ClienteNovosMovimentacao'),
      DashboardGraficoPositivacaoClientesNovosAnual: () => import('../../graficos/Comercial/PositivacaoClienteAnual'),
      DashboardGraficoClienteSemMovimentacaoAnual: () => import('../../graficos/Comercial/ClienteSemMovimentacaoAnual'),
      DashboardGraficoClienteNovosSemMovimentacaoAnual: () => import('../../graficos/Comercial/ClienteNovosSemMovimentacaoAnual'),
      DashboardGraficoClienteNovosMovimentacaoAnual: () => import('../../graficos/Comercial/ClienteNovosMovimentacaoAnual'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      select: [],
      empresa: [],
      link: window.location.href,
      clientes: [],
      cidades: [],
      areas: [],
      vendedores: [],
      redes: [],
      produtos: [],
      segmento: [],
      paginaEnable: true,
      enableEmpresa: true,
      enableClientes: false,
      enableCidades: true,
      enableAreas: true,
      enableVendedores: true,
      enableRedes: true,
      enableProdutos: false,
      enableLinhas: false,
      enableSegmento: true,
      clienteTotal: 0,
      enableBtn: true,
      disableBtn: false,
      codigo: 0,
      orientacao: [],
      textoPositivaoCliente: '',
      textoPositivaoClienteAnual: '',
      codigoIds: ['232', '340'],
      dynamicPaddingPositicaoCliente: '',
      enableBtnPrint: false,
      imprimindo: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.dataInicial)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.dataFinal)
      },
    },

    created () {
      eventEmit.$on('update-dados-mais-vida', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-mais-vida', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Positivação Clientes')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingPositicaoCliente = 'padding-right: 107rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingPositicaoCliente = 'padding-right: 85rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingPositicaoCliente = 'padding-right: 10rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingPositicaoCliente = 'padding-right: 30rem !important'
        } else {
          this.dynamicPaddingPositicaoCliente = 'padding-right: 68rem !important'
        }
      },

      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, redeSelect, vendedorSelect, produtoSelect, linhaSelect, clienteSelect, caixaSelect, tipoDevolucao, motivoDevolucao, dataInicial1, dataFinal1, empresaSelect1, cidadeSelect1, areaSelect1, redeSelect1, vendedorSelect1, produtoSelect1, linhaSelect1, clienteSelect1, caixaSelect1, receita, segmento, segmento1) {
        this.select = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.clientes = clienteSelect
        this.segmento = segmento

        this.enableBtnPrint = false

        this.updateDados()
        this.totalClientes()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      updateDados () {
        eventEmit.$emit('update-form-mais-vida', this.select, this.cidades, this.areas, this.vendedores, this.redes, this.produtos, this.linhas, this.clientes, this.segmento)
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async totalClientes () {
        this.loading = true

        this.clienteTotal = 0

        await PositivacaoCliente.showDadosClientesTotais(this.select, this.cidades, this.areas, this.vendedores, this.redes, localStorage.tokencontrato, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.clienteTotal = resposta.data.cliente

            this.enableBtnPrint = true
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          let posYFiltros = 10
          // Definir a margem esquerda
          const marginLeftRem = -1
          const marginLeftPx = marginLeftRem * 16

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          posYFiltros += 10

          pdf.setFontSize(10)

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

          if (posYFiltros > 150) {
            pdf.addPage()

            posYFiltros = 10
          }

          const totalClientes = 'Clientes Totais: ' + this.clienteTotal
          pdf.setFontSize(16)
          pdf.text(totalClientes, 105, posYFiltros)

          posYFiltros += 5

          const graficoMeses = document.getElementById('participacaoUltimosMesesPrint')
          const canvasGraficoMeses = await html2canvas(graficoMeses)
          const imgWidthGraficoMeses = 297
          const imgHeightGraficoMeses = (canvasGraficoMeses.height * imgWidthGraficoMeses) / canvasGraficoMeses.width

          pdf.addImage(canvasGraficoMeses.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthGraficoMeses, imgHeightGraficoMeses)

          posYFiltros += imgHeightGraficoMeses

          if (posYFiltros > 150) {
            pdf.addPage()

            posYFiltros = 10
          }

          const graficoAno = document.getElementById('participacaoUltimoAnoPrint')
          const canvasGraficoAno = await html2canvas(graficoAno)
          const imgWidthGraficoAno = 297
          const imgHeightGraficoAno = (canvasGraficoAno.height * imgWidthGraficoAno) / canvasGraficoAno.width

          pdf.addImage(canvasGraficoAno.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthGraficoAno, imgHeightGraficoAno)

          posYFiltros += imgHeightGraficoAno

          pdf.save('relatorio_posticao_cliente.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {

  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1380px) {

  }
</style>

<style lang="sass">
  #clienteTempo
    max-width: 1800px !important

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemPositivacaoCliente
    padding-right: 100rem !important
    margin: -2rem 0 0 -1rem

</style>
